export enum AccessMatrixLevel {
  NoAccess = 'NoAccess',
  Review = 'Review',
  Edit = 'Edit'
}
